import envBeta from '@/env/env.beta';
import envProd from '@/env/env.prod';
import envRelease from '@/env/env.release';
import envDev from '@/env/env.dev';
import { ENV } from '@/env/types';

function getValueByEnv<T = ENV>(allEnvData: Record<'envDev' | 'envProd' | 'envRelease' | 'envBeta', T>) {
  // NODE_ENV 只有两个值一个是production一个是development
  // 本地开发
  if (process.env.NODE_ENV === 'development') return allEnvData.envDev;

  // 打包发版(生产 | 预发)
  // 接口环境
  // 生产环境
  if (process.env.API_ENV === 'production') return allEnvData.envProd;

  // 预发 / 准线上环境
  if (process.env.API_ENV === 'release') return allEnvData.envRelease;

  // 测试环境
  if (process.env.API_ENV === 'beta') return allEnvData.envBeta;

  return allEnvData.envProd;
}

let env: ENV = getValueByEnv({ envDev, envProd, envRelease, envBeta });

export const ACE_API_DOMAIN = env.ACE_API_DOMAIN;
